import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { baseUrl, config, requestID } from "../../../common/utils";
import {
  Box, Card, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography, IconButton, Stack,
  CircularProgress, Paper, Container, Chip
} from '@mui/material';
import {
  DeleteSweep as WriteOffIcon,
  Refresh as RefreshIcon,
  Info as InfoIcon
} from '@mui/icons-material';
import { IonContent, IonPage } from '@ionic/react';

interface WriteOffLog {
  id: number;
  stock_name: string;
  ecid_item: string;
  quantity: number;
  date_time: string;
  from_location: string;
  reason: string; // e.g., 'Expired', 'Damaged'
  signer_out_name: string;
}

const ReorderLevels: React.FC = () => {
  const [logs, setLogs] = useState<WriteOffLog[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      const res = await axios.post(`${baseUrl()}Geacloud_Inventorys/getWriteOffLogs`, formData, config);
      if (res.data.status) setLogs(res.data.data || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchLogs(); }, []);

  return (
    <IonPage>
      <IonContent>
    <Box sx={{ backgroundColor: '#f5f7fb', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ background: 'linear-gradient(to right, #1e293b, #334155)', px: 3, py: 5, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <Container maxWidth="xl">
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Box>
              <Typography variant="h4" fontWeight={700} color="white">Stock Write-Offs</Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>Historical record of damaged, expired, or lost inventory.</Typography>
            </Box>
            <IconButton onClick={fetchLogs} sx={{ bgcolor: 'rgba(255,255,255,0.1)', color: 'white' }}><RefreshIcon /></IconButton>
          </Stack>
        </Container>
      </Box>

      <Container maxWidth="xl" sx={{ mt: -3, mb: 4, flex: 1 }}>
        <Card sx={{ borderRadius: 4, boxShadow: '0 10px 25px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 'calc(100vh - 300px)' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700, bgcolor: '#f8fafc' }}>S/N</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: '#f8fafc' }}>ITEM</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: '#f8fafc' }}>LOCATION</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700, bgcolor: '#f8fafc' }}>QTY LOST</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: '#f8fafc' }}>REASON</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: '#f8fafc' }}>DATE</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow><TableCell colSpan={6} align="center" sx={{ py: 10 }}><CircularProgress /></TableCell></TableRow>
                ) : logs.map((log, index) => (
                  <TableRow key={log.id} hover>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight={600}>{log.stock_name}</Typography>
                      <Typography variant="caption" color="text.secondary">{log.ecid_item}</Typography>
                    </TableCell>
                    <TableCell>{log.from_location}</TableCell>
                    <TableCell align="right" sx={{ color: '#dc2626', fontWeight: 700 }}>-{log.quantity}</TableCell>
                    <TableCell>
                      <Chip label={log.reason || 'General Loss'} size="small" variant="outlined" color="error" />
                    </TableCell>
                    <TableCell sx={{ fontSize: '0.8rem' }}>{new Date(log.date_time).toLocaleString()}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Container>
    </Box>
      </IonContent>
    </IonPage>

  );
};

export default ReorderLevels;